module.exports = __webpack_public_path__ + "img/meter-sell-unit-grey.bc5abd71.svg";